<template>
<div class="container" id="cooperate">
  <section>
    <div class="row">
      <div class="col-12">
        <div class="page section-group">
          <div class="card p-5">
            <h1 class="page-title mb-2"> {{$t('common.cooperate.t1')}} </h1>
            <hr class="divider">
            <div class="page-content mb-4">
              <div class="contact section-group">
                <p>{{$t('common.cooperate.t2')}}
                <div class="row">
                  <div class="col-md-6"> <b>{{$t('common.cooperate.t3')}}</b><br>
                    <i class="fa fa-phone-alt fa-fw mr-2"></i>{{$t('common.cooperate.t4')}}<br>
                    <i class="fa fa-envelope fa-fw mr-2"></i><a href="mailto:sales_tw@soonnet.org">sales_tw@soonnet.org</a> </div>
                  <div class="col-md-6"> <b>{{$t('common.cooperate.t5')}}</b><br>
                    <i class="fa fa-phone-alt fa-fw mr-2"></i>852-2197-5566<br>
                    <i class="fa fa-envelope fa-fw mr-2"></i><a href="mailto:sales@soonnet.org">sales@soonnet.org</a> </div>
                </div>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ./頁面內容 --> 
</div>
</template>
<script>
export default {
  data() {},
   created() {
    this.$store.dispatch("updateCurrentIndex", 0);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/cooperate.vue